angular.module('domain.looker', ['ngRoute', 'upResources', 'security.authorization']).config([
	'$stateProvider',
	function ($stateProvider) {
		// Empty twin state for the React Insights route (routes/index.tsx, sameAngularPath).
		// Keeps the 'looker' state name + url so $state.go('looker') consumers (Navbar,
		// CreateReportModal, startpageHelper, …) and the route's twin requirement keep working;
		// React renders the actual page. Auth and 'View looker' tracking live on the React side
		// (InsightsAllowed + PortedInsights).
		$stateProvider.state('looker', {
			url: '/:customerId/insights/:type?/:id?useNext',
			template: '<div></div>',
			section: 'followup',
			params: {
				dashboards: { value: null },
				explores: { value: null },
				looks: { value: null }
			}
		});
	}
]);
